'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

/** Корень: учитываем JWT в localStorage (сервер его не видит). */
export default function Home() {
  const router = useRouter()

  useEffect(() => {
    const token = localStorage.getItem('token')
    router.replace(token ? '/dashboard' : '/login')
  }, [router])

  return (
    <div className="app-layout" style={{ padding: 24 }}>
      Загрузка...
    </div>
  )
}
